import { useBoolean } from 'aa_common/front-end/hooks'

const AI_CONSENT_STORAGE_KEY = 'ASSET_FORM_AI_CONSENT_OFFICE_IDS'

const getAIConsentOfficeIds = (): number[] => {
  try {
    const raw = localStorage.getItem(AI_CONSENT_STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    return Array.isArray(parsed) ? parsed.filter((id): id is number => typeof id === 'number') : []
  } catch {
    return []
  }
}

export function hasAIConsentForOffice(officeId?: number): boolean {
  if (!officeId) return false
  return getAIConsentOfficeIds().includes(officeId)
}

const saveAIConsentForOffice = (officeId?: number): void => {
  if (!officeId) return
  const ids = getAIConsentOfficeIds()
  if (ids.includes(officeId)) return
  localStorage.setItem(AI_CONSENT_STORAGE_KEY, JSON.stringify([...ids, officeId]))
}

export const useAIAssistantDrawer = (officeId: number, onTryAgain?: () => void) => {
  const [visible, setTrue, setFalse] = useBoolean(false)
  const [showConfirmDialog, setShowConfirmDialog, setHideConfirmDialog] = useBoolean(false)

  const openDrawer = () => {
    setTrue()
    setHideConfirmDialog()
  }

  return {
    visible,
    closeDrawer: () => {
      setFalse()
      onTryAgain?.()
    },
    openDrawer,
    showConfirmDialog,
    opShowConfirmDialog: () => {
      if (hasAIConsentForOffice(officeId)) {
        openDrawer()
      } else {
        setShowConfirmDialog()
      }
    },
    onHideConfirmDialog: () => setHideConfirmDialog(),
    onAgreeWithConsent: () => {
      saveAIConsentForOffice(officeId)
      openDrawer()
    },
  }
}
